import { Layout, Skeleton } from "antd";
import React, { useContext, useRef, useState } from "react";
import {
  initPrestationSlice,
  setPropertiesPrestation,
  updatePrestation,
} from "../Slices/Prestation.slice";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomForm from "../../../shared/components/CustomForm";
import routes from "../../../engine/routes";
import { prestationInputs } from "./PrestationDetailForm";
import { PrestationHeader } from "../../../shared/components/PrestationHeader/PrestationHeader";
import { UserContext } from "../../../engine/context/User.context";
import {
  RenderCommentAdmin,
  RenderControl1,
  RenderControl2,
} from "../PrestationResume/PrestationsResumeActions";
import { usePrestationDisabler } from "../../../engine/hooks/usePrestationDisabler";
import { isSuperAdmin } from "../../../engine/hooks/hooks.helpers";

const { Content, Sider, Header, Footer } = Layout;

export function PrestationDetail({ isNew }) {
  const { id } = useParams();
  const { prestation, loading } = useSelector(state => state.prestation);
  const { init, clear, ready } = initPrestationSlice({ id });
  const [change, setChange] = useState(undefined);
  const { user } = useContext(UserContext);

  const superAdmin = isSuperAdmin();

  const [disabled] = usePrestationDisabler();

  const dispatch = useDispatch();
  const formRef = useRef(null);
  const navigate = useNavigate();

  const onSubmitForm = async data => {
    /* Check if data.steps exists, and if not, create it as an empty object
     * data.steps ??= {} checks if data.steps is null or undefined. If it is, it creates an empty object {} and assigns it to data.steps. If data.steps already exists, it remains unchanged.
     * */
    data.steps ??= {};

    data.steps.searchInterpretes = true;

    await dispatch(setPropertiesPrestation(data));
    let actionResult = await dispatch(updatePrestation());

    if (
      actionResult.meta.requestStatus !== "rejected" &&
      prestation._id !== undefined
    ) {
      await navigate(routes.prestations(id).detailInterpretes.path);
    }
  };

  const onValuesChange = changedValues => {
    Object.keys(changedValues).map(changed => {
      switch (changed) {
        case "institution":
          if (
            prestation.institution !== undefined &&
            (prestation.institution._id !== undefined ||
              prestation.institution._id !== changedValues[changed])
          ) {
            const body = {
              billing: null,
              institutionBilling: null,
            };

            if (!superAdmin) {
              body.steps = {
                ...prestation.steps,
                facturation: false,
                resume: false,
              };
            }

            dispatch(setPropertiesPrestation(body));
          }

          formRef.current.setFieldsValue({
            applicant: undefined,
            "intervention.extra": "",
            "intervention.locationFrom": "",
            "intervention.location": "",
            "intervention.locationName": "",
            "responsable.firstname": "",
            "responsable.email": "",
            "responsable.phone": "",
            "responsable.lastname": "",
          });

          dispatch(
            setPropertiesPrestation({
              intervention: {
                ...prestation.intervention,
                extra: "",
                locationFrom: "",
                location: "",
                locationName: "",
              },
              responsable: {
                firstname: "",
                email: "",
                phone: "",
                lastname: "",
              },
            }),
          );

          break;
      }
    });
  };

  return (
    <div key={prestation._id || "new"}>
      <PrestationHeader title={routes.prestations(id).detail.title} />
      {loading || !ready ? (
        <Skeleton active />
      ) : (
        <>
          <br />
          <RenderCommentAdmin key={prestation._id} />
          <RenderControl1 key={prestation._id} />
          <RenderControl2 key={prestation._id} />
          <CustomForm
            disabled={disabled}
            initialValues={prestation}
            dataSource={prestationInputs(
              prestation,
              formRef,
              change,
              setChange,
              user,
            )}
            handleSubmit={data => onSubmitForm(data)}
            labelCol={24}
            refForm={formRef}
            wrapperCol={24}
            onValuesChange={onValuesChange}
          />
        </>
      )}
    </div>
  );
}
